import { ColDef } from "ag-grid-community";
import { TableCellButton } from "./table-cell-button.model";
import { TableRow } from "./table-row.model";

export class TableCellEvent {

    constructor (public value: any, public row: TableRow, public column: ColDef, public rowIndex: number, public columnIndex: number) {
    }

    isButton(buttonName: string, columnId?: string) {
        return this.value instanceof TableCellButton && (this.value as TableCellButton).id == buttonName && (columnId == null || columnId == this.column.colId); 
    }

}
